/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ recipients: NonNullable<unknown> }} Ccsl_Export_Recipient_OnlyInputs */

const en_ccsl_export_recipient_only = /** @type {(inputs: Ccsl_Export_Recipient_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`TO: ${i?.recipients}`)
};

const fr_ccsl_export_recipient_only = /** @type {(inputs: Ccsl_Export_Recipient_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`TO: ${i?.recipients}`)
};

const de_ccsl_export_recipient_only = /** @type {(inputs: Ccsl_Export_Recipient_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AN: ${i?.recipients}`)
};

const it_ccsl_export_recipient_only = /** @type {(inputs: Ccsl_Export_Recipient_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A: ${i?.recipients}`)
};

const ru_ccsl_export_recipient_only = /** @type {(inputs: Ccsl_Export_Recipient_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`КОМУ: ${i?.recipients}`)
};

const es_ccsl_export_recipient_only = /** @type {(inputs: Ccsl_Export_Recipient_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`PARA: ${i?.recipients}`)
};

const zh_cn2_ccsl_export_recipient_only = /** @type {(inputs: Ccsl_Export_Recipient_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`收件人：${i?.recipients}`)
};

const ja_ccsl_export_recipient_only = /** @type {(inputs: Ccsl_Export_Recipient_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`宛先: ${i?.recipients}`)
};

const hi_ccsl_export_recipient_only = /** @type {(inputs: Ccsl_Export_Recipient_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रति: ${i?.recipients}`)
};

const pt_pt2_ccsl_export_recipient_only = /** @type {(inputs: Ccsl_Export_Recipient_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`PARA: ${i?.recipients}`)
};

/**
* | output |
* | --- |
* | "TO: {recipients}" |
*
* @param {Ccsl_Export_Recipient_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_recipient_only = /** @type {((inputs: Ccsl_Export_Recipient_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Recipient_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_recipient_only(inputs)
	if (locale === "de") return de_ccsl_export_recipient_only(inputs)
	if (locale === "it") return it_ccsl_export_recipient_only(inputs)
	if (locale === "ru") return ru_ccsl_export_recipient_only(inputs)
	if (locale === "es") return es_ccsl_export_recipient_only(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_recipient_only(inputs)
	if (locale === "ja") return ja_ccsl_export_recipient_only(inputs)
	if (locale === "hi") return hi_ccsl_export_recipient_only(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_recipient_only(inputs)
	return en_ccsl_export_recipient_only(inputs)
});